export function getSlides(splide) {
    const children = splide.Components.Elements?.list.children;
    return children && Array.prototype.slice.call(children) || [];
}
